import { ReactComponent as Pencil } from 'assett/icons/pencil.svg';
import { ReactComponent as UploadCompleted } from 'assett/icons/upload_completed.svg';
import DeletePopup from 'components/UploadFile/DeletePopup';
import { useState } from 'react';
import { Box, IconButton, Paper, Stack, Typography } from 'styles';
import { IFileType } from 'types/Claim';
import { STATE_KEYS } from 'types/Store';
import { DocType } from 'types/Upload';
import FileNameEditor from '../FileNameEditor';

const DocumentCard = ({
	uuid,
	fileName,
	documentType,
	clearDocumentsKey,
}: IFileType & { documentType: DocType; clearDocumentsKey: STATE_KEYS }) => {
	const [isEditMode, setIsEditMode] = useState(false);

	const enableEditModeAction = () => {
		setIsEditMode(true);
	};

	return (
		<Paper
			elevation={0}
			sx={{
				px: '16px',
				py: '25px',
				maxHeight: '90px',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
			}}
		>
			<Stack
				flexDirection={'row'}
				alignItems={'center'}
				justifyContent={'space-between'}
			>
				<Stack flexDirection={'row'} alignItems={'center'} gap={'10px'}>
					<Box display="flex" p={0}>
						<UploadCompleted />
					</Box>
					{!isEditMode && (
						<Typography variant={'value2'} sx={{ textDecoration: 'underline' }}>
							{fileName}
						</Typography>
					)}
					{isEditMode && (
						<FileNameEditor
							documentType={documentType}
							data={{ uuid, fileName: fileName || '' }}
							isEditMode={isEditMode}
							setIsEditMode={setIsEditMode}
						/>
					)}
				</Stack>
				<Stack flexDirection={'row'} alignItems={'center'} gap={'20px'}>
					<IconButton onClick={enableEditModeAction}>
						<Pencil />
					</IconButton>
					<DeletePopup
						data={{ uuid, fileName: fileName || '' }}
						documentType={documentType}
						clearDocumentsKey={clearDocumentsKey}
					/>
				</Stack>
			</Stack>
		</Paper>
	);
};

export default DocumentCard;
